<template>
    <div class="group">
        <div v-for="option in options" :key="option.value">
            <input
                type="radio"
                :id="`${name}-${option.value}`"
                :name="name"
                :checked="value === option.value"
                @input="$emit('input', option.value);"
            />
            <label :for="`${name}-${option.value}`">{{ option.label }}</label>
        </div>
    </div>
</template>

<script>
export default {
    props: ["value", "options", "name"]
};
</script>
<style lang="scss" scoped>
.group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
        grid-row-gap: 4px;
    }

    label {
        text-transform: uppercase;
        font-weight: bold;
        margin-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// radio-group.vue?1f72084f